<template>
  <div>
    <form>
      <template v-if="isAdmin">
        <custom-select-single
          label="BManager"
          :options="users"
          :value="selectedUser"
          @input="$store.commit('changeSelectedUser', $event)"
          :required="true"
        />
      </template>

      <custom-select-single
        label="Country"
        :options="countries"
        :value="selectedCountry"
        @input="$store.commit('changeSelectedCountry', $event)"
        :required="true"
      />

      <p style="margin-top: -10px;">
        <template v-if="selectedCountry && selectedCountry.currency">
          Currency: {{ selectedCountry.currency }}
        </template>
        <template v-if="selectedCountry && selectedCountry.vat">
          VAT: {{ selectedCountry.vat }}%
        </template>
        <template v-if="selectedCountry && selectedCountry.import_duties">
          Import Duties: {{ selectedCountry.import_duties }}%
        </template>
      </p>

      <custom-select-single
        label="Distributor"
        :options="distributors"
        :value="selectedDistributor"
        @input="$store.commit('changeSelectedDistributor', $event)"
        selectLabel="company_name"
      />

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="start_date" class="custom-label">Start of <span v-text="stepType === 'trial' ? 'Trial' : 'Roll Out'"></span></label>
            <datepicker
              format="dd.MM.yyyy"
              :value="startDate"
              @input="$store.commit('changeStartDate', $event)"
              :bootstrap-styling="true"
              input-class="bg-white"
            />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="custom-label" v-text="stepType === 'trial' ? 'Provisional test period' : 'Business Case period'"></label>
            <custom-input-group
              :appendLabel="stepType === 'trial' ? 'Months' : 'Years'"
              :value="testPeriod"
              @input="$store.commit('changeTestPeriod', $event)"
            />
          </div>
        </div>
      </div>

      <div class="form-group" v-if="! nav">
        <label class="custom-label" for="logo">Logo</label>
        <br>
        <input type="file" name="logo" id="logo"
          v-if="! logoPath"
          @change="uploadLogo"
        >
        <button class="btn btn-secondary btn-sm"
          @click.prevent="deleteLogo"
          v-else
        >
          Delete Logo <i class="fa fa-trash-alt"></i>
        </button>
      </div>

      <div class="form-group" v-if="! nav && stepType === 'rollOut'">
        <label class="custom-label" for="logo">Add Equipment / Change Business Case Period</label>
        <br>
        <button type="button" class="btn btn-sm btn-primary"
          @click="$emit('addChange')"
        >
          <i class="fa fa-plus"></i> Add Equipment / Change Business Case Period
        </button>
        <div style="margin-top: 1rem;">
          <ul class="list-group" v-if="changes.length">
            <li class="list-group-item d-flex justify-content-between align-items-center"
              v-for="change in changes"
            >
              {{ change.date | date }}
              <div v-text="change.printers"></div>
              <div v-text="change.contract"></div>
              <div>
                <button type="button" class="btn btn-warning btn-sm"
                  @click="$emit('openEditChangeModal', change)"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn btn-secondary btn-sm"
                  @click="$emit('deleteChange', change)"
                >
                  <i class="fa fa-trash-alt"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div style="margin-top: 1em;" v-if="nav">
        <button type="button" class="btn btn-primary float-right"
          @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create/2`)"
          v-text="'Next'"
          :disabled="! $store.getters.firstStepIsValid"
        />
      </div>
      <template v-else>
        <button class="btn btn-primary float-right"
          v-if="isAdmin || isFromAuthUser"
          @click.prevent="$emit('update')"
          style="margin-bottom: 1em;"
        >
          <i class="fa fa-edit"></i> Save
        </button>
      </template>
    </form>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import StepMixin from './step-mixin'
  import { date } from  './../../filters'

  export default {
    mixins: [ StepMixin ],
    props: {
      uploadUrl: {
        default: '',
      },
    },
    filters: {
      date,
    },
    data() {
      return {
        countries: [],
        distributors: [],
        users: [],
        test: null,
      }
    },
    computed: {
      ...mapState(['testPeriod', 'selectedCountry', 'distributor', 'startDate', 'selectedUser', 'logoPath', 'changes', 'selectedDistributor']),
    },
    methods: {
      uploadLogo(event) {
        const formData = new FormData
        formData.append('file', event.target.files[0])
        axios.post(this.uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(({data}) => {
          this.$store.commit('changeLogoPath', data)
          window.notification.success('Logo has been uploaded', 'Success!')
        })
      },
      deleteLogo() {
        if (confirm('Do you really want to delete the logo?')) {
          axios.delete(this.uploadUrl).then(({data}) => {
            this.$store.commit('changeLogoPath', '')
            window.notification.success('Logo has been deleted', 'Success!')
          })
        }
      },
    },
    mounted() {
      axios.get('/api/countries').then(({data}) => this.countries = data)
      axios.get('/api/users').then(({data}) => this.users = data)
      axios.get('/api/distributors').then(({data}) => this.distributors = data)
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/CreateStep1.vue